import dxButton from "devextreme/ui/button";
import dxLoadPanel from "devextreme/ui/load_panel";
import dxNotify from "devextreme/ui/notify";
import dxPopup from "devextreme/ui/popup";
import dxSelectBox from "devextreme/ui/select_box";
import ControleSessao from "../componentes-padrao/ControleSessao";
import { getCarriersAllowed, logout, setTransportador } from "../services/auth/api";

/**
 * Popup exibido quando o usuário possui vínculo de transportador externo.
 * Permite escolher entre logar como transportador externo (redireciona para o
 * portal do transportador) ou seguir com o login normal (embarcadora/empresa).
 */
export class SelecionaTipoAcesso {
    /**
     * @param {{ onLoginNormal: () => void, somenteTransportador?: boolean }} opcoes
     * @param opcoes.somenteTransportador Quando true, o usuário só possui acesso
     *   ao portal do transportador: pulamos a escolha de plataforma e vamos
     *   direto à seleção do transportador.
     */
    constructor({ onLoginNormal, somenteTransportador = false }) {
        this.onLoginNormal = onLoginNormal;
        this.somenteTransportador = somenteTransportador;

        if ($("#popup").length === 0) {
            $(".raster-app").append("<div id='popup' />");
        }

        this.loading = new dxLoadPanel($(".loadpanel"), {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { my: "center", at: "center" },
            visible: false,
            showIndicator: true,
            showPane: true,
            shading: true,
            closeOnOutsideClick: false,
            message: "Carregando, aguarde.",
        });

        this.render();
    }

    render() {
        const content = $("#popup");

        this.popup = new dxPopup(content, {
            dragEnabled: false,
            visible: true,
            title: this.somenteTransportador
                ? "Selecione o transportador"
                : "Como deseja acessar?",
            fullScreen: false,
            resizeEnabled: false,
            showCloseButton: false,
            deferRendering: false,
            width: () => {
                if (window.innerWidth > 450) {
                    return "450px";
                }
                return `${window.innerWidth - 108}px`;
            },
            height: "auto",
            shadingColor: "rgba(17, 95, 157, 0)",
            position: { my: "center", at: "center", of: window },
            contentTemplate: (conteudo) => {
                this.conteudo = conteudo;

                if (this.somenteTransportador) {
                    return;
                }

                $(`<div class="selecionar-empresa-logo"/>`).appendTo(conteudo);
                this.renderEscolhaTipo(conteudo);
            },
            onHiding: (e) => (e.cancel = true),
        });

        this.popup.show();

        if (this.somenteTransportador) {
            this.renderSelecaoTransportador(this.conteudo);
        }

        const fundoLogin = $(`<div class="bg-imagem"></div>`);
        content.append(fundoLogin);

        return content;
    }

    renderEscolhaTipo(conteudo) {
        $(conteudo).empty();

        const container = $(
            "<div style='display: flex; flex-direction: column; gap: 15px; margin-top: 15px;' />",
        ).appendTo(conteudo);

        const botaoTransportador = $("<div />").appendTo(container);
        new dxButton(botaoTransportador, {
            text: "Portal do transportador",
            icon: "car",
            type: "normal",
            stylingMode: "outlined",
            width: "100%",
            onClick: () => this.renderSelecaoTransportador(conteudo),
        });

        const botaoLoginNormal = $("<div />").appendTo(container);
        new dxButton(botaoLoginNormal, {
            text: "ePonto",
            icon: "user",
            type: "normal",
            stylingMode: "outlined",
            width: "100%",
            onClick: () => this.prosseguirLoginNormal(),
        });
    }

    renderSelecaoTransportador(conteudo) {
        $(conteudo).empty();
        this.popup.option("title", "Selecione o transportador");

        $(`<div class="selecionar-empresa-logo"/>`).appendTo(conteudo);

        const labelTransportador = $(
            "<div style='margin-top: 15px;'>Transportador:</div>",
        ).appendTo(conteudo);

        const campoTransportador = $("<div />").appendTo(labelTransportador);
        const selectTransportador = new dxSelectBox(campoTransportador, {
            dataSource: [],
            displayExpr: "reason",
            valueExpr: "id",
            searchEnabled: true,
            disabled: true,
            placeholder: "Carregando... Aguarde.",
            onValueChanged: ({ component }) => {
                component.option("validationStatus", "valid");
            },
        });

        getCarriersAllowed()
            .then((transportadores) => {
                selectTransportador.option("dataSource", transportadores);
                selectTransportador.option("disabled", false);
                selectTransportador.option(
                    "placeholder",
                    "Selecione um transportador",
                );

                // Mesmo com um único transportador, não fazemos auto-select/
                // redirect: apenas deixamos a opção pré-selecionada e mantemos a
                // tela visível para o usuário decidir entre entrar ou sair
                // (do contrário o usuário somente-transportador ficaria preso em
                // um loop de login automático, sem conseguir deslogar).
                if (transportadores.length === 1) {
                    selectTransportador.option("value", transportadores[0].id);
                } else {
                    selectTransportador.open();
                }
            })
            .catch((error) => {
                console.error(error);
                dxNotify(
                    "Não foi possível carregar os transportadores.",
                    "error",
                    2500,
                );
            });

        const rodape = $(
            `<div style='display: flex; justify-content: space-between; align-items: center; gap: 10px; margin-top: 20px; margin-bottom: 5px;' />`,
        ).appendTo(conteudo);

        const acoesSecundarias = $(
            "<div style='display: flex; align-items: center; gap: 15px; margin-left: 5px;' />",
        ).appendTo(rodape);

        // O "Voltar" só faz sentido quando há a tela anterior de escolha de
        // plataforma. No fluxo somente transportador não há para onde voltar.
        if (!this.somenteTransportador) {
            const botaoVoltar = $("<div />").appendTo(acoesSecundarias);
            new dxButton(botaoVoltar, {
                text: "Voltar",
                icon: "chevronleft",
                type: "normal",
                stylingMode: "outlined",
                onClick: () => {
                    this.popup.option("title", "Como deseja acessar?");
                    this.renderEscolhaTipo(conteudo);
                },
            });
        }

        // "Sair" precisa existir na própria tela de seleção para que o usuário
        // somente-transportador não fique preso — encerra a sessão no Keycloak.
        // Segue o mesmo padrão discreto de link usado na seleção de empresa.
        const botaoSair = $(
            "<span style='cursor: pointer; color: #777; font-size: 12px; text-decoration: underline;'>Sair</span>",
        ).appendTo(acoesSecundarias);
        botaoSair.on("click", () => this.sair());

        // Mesmo estilo do "Prosseguir" da seleção de empresa (#login-button):
        // outlined com borda/ícone temáticos, evitando o fundo/ícone escuros.
        const botaoProsseguir = $('<div id="login-button" />').appendTo(rodape);
        new dxButton(botaoProsseguir, {
            text: "Prosseguir",
            icon: "chevronright",
            type: "normal",
            stylingMode: "outlined",
            onClick: async () => {
                const transportadorID = selectTransportador.option("value");

                if (!transportadorID) {
                    selectTransportador.option(
                        "validationStatus",
                        "invalid",
                    );
                    return;
                }

                await this.acessarComoTransportador(transportadorID);
            },
        });
    }

    async acessarComoTransportador(transportadorID) {
        try {
            this.loading.show();

            await setTransportador({ transportadorID });

            this.redirecionarParaPortal();
        } catch (error) {
            console.error(error);
            dxNotify("Tente novamente.", "error", 2500);
        } finally {
            this.loading.hide();
        }
    }

    /**
     * Encerra a sessão do usuário no Keycloak e recarrega a aplicação. Após o
     * reload, sem sessão ativa, o Keycloak volta a exibir a tela de login (não
     * há re-autenticação automática). Mesmo se o logout no backend falhar,
     * recarregamos para não deixar o usuário preso.
     */
    async sair() {
        try {
            this.loading.show();
            const refreshToken = ControleSessao.getRefreshToken();
            await logout(refreshToken);
        } catch (error) {
            console.error(error);
        } finally {
            window.location.reload();
        }
    }

    redirecionarParaPortal() {
        const accessToken = ControleSessao.getToken();
        const refreshToken = ControleSessao.getRefreshToken();

        const portalUrl = process.env.PORTAL_TRANSPORTADOR_URL;

        if (!portalUrl) {
            console.error("PORTAL_TRANSPORTADOR_URL não configurada.");
            dxNotify(
                "Portal do transportador não configurado.",
                "error",
                2500,
            );
            return;
        }

        const fragmento = new URLSearchParams({
            access_token: accessToken,
            refresh_token: refreshToken,
        });

        window.location.href = `${portalUrl}#${fragmento.toString()}`;
    }

    prosseguirLoginNormal() {
        this.popup.dispose();
        $("#popup").remove();
        $(".raster-app").append("<div id='popup' />");

        this.onLoginNormal();
    }
}
